import React from 'react';
import { AggregatedOrganizationStatsData } from '../../../utils/organization-stats-handlers';
import CustomBarChart from '../../data-widgets/CustomBarChart';
import { useTranslation } from 'react-i18next';
import { dateToStringFormat } from '@common/utils/date';
import { DateTime } from 'luxon';
import useDistanceUnitValue from '@common/hooks/useDistanceUnitValue';
import { DistanceValueUnit } from '@common/enums/configuration/units';

const WeeklyCleanedAreaChart: React.FC<{
  aggregatedData: AggregatedOrganizationStatsData | null;
  loading?: boolean;
  skipAnimation?: boolean;
  filterWeeks: (week: string) => boolean;
}> = ({ aggregatedData, loading, skipAnimation, filterWeeks }) => {
  const { t } = useTranslation();
  const { label, multiplier } = useDistanceUnitValue(0, DistanceValueUnit.METERS_SQUARED);

  return (
    <React.Fragment>
      <CustomBarChart
        title={t('label-weekly-cleaned-area')}
        loading={loading}
        skipAnimation={skipAnimation}
        xAxis={[
          {
            data: (aggregatedData?.chartData ?? [])
              .filter((data) => filterWeeks(data.week))
              .map((data) => data.week),
            label: t('label-week'),
            scaleType: 'band',
            valueFormatter: (date) => dateToStringFormat(DateTime.fromISO(date), true),
          },
        ]}
        series={[
          {
            data: (aggregatedData?.chartData ?? [])
              .filter((data) => filterWeeks(data.week))
              .map((data) => data.cleanedArea * multiplier),
          },
        ]}
        yLabel={label}
      />
    </React.Fragment>
  );
};

export default WeeklyCleanedAreaChart;
